import FocusTrapReact from 'focus-trap-react';
import { ComponentProps } from 'react';

export default function FocusTrap({
  children,
  /**
   * Skips rendering FocusTrap entirely, avoiding all side effects.
   * `active={false}` still triggers some side effects.
   * Use `disabled` if the focus trap isn't intended to be used AT ALL for the
   * current component (e.g. you are on mobile).
   */
  disabled,
  ...props
}: ComponentProps<typeof FocusTrapReact> & { disabled?: boolean }) {
  return disabled ? <>{children}</> : <FocusTrapReact {...props}>{children}</FocusTrapReact>;
}
